function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { ComponentWrapper, MediaContextProvider } from "./..";
import MobileHeader from "./MobileHeader";
import { NavigationHeaderContext } from "./NavigationHeaderContext";
import PcHeader from "./PcHeader";
import "./styles/index.less";
import { isMobile } from "../utils";
import LoginCasSDK from '@digit-fe/digit-cas-sdk';
import cx from 'classnames';
import React, { forwardRef, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var _require = require('path-to-regexp'),
    pathToRegexp = _require.pathToRegexp;

var NavigationHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var navItem = props.navItem,
      searchComponent = props.searchComponent,
      onSiteNameClick = props.onSiteNameClick,
      onMonitorChange = props.onMonitorChange,
      siteName = props.siteName,
      className = props.className,
      uid = props.uid,
      username = props.username,
      _props$env = props.env,
      env = _props$env === void 0 ? 'test' : _props$env,
      onLogout = props.onLogout,
      onLogin = props.onLogin,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? [] : _props$menu,
      rightMenu = props.rightMenu,
      onSearch = props.onSearch,
      onMenuClick = props.onMenuClick,
      onLogoClick = props.onLogoClick,
      dropDownMenu = props.dropDownMenu,
      _props$testPassportUr = props.testPassportUrl,
      testPassportUrl = _props$testPassportUr === void 0 ? 'https://passport.fanruan.com' : _props$testPassportUr,
      _props$prodPassportUr = props.prodPassportUrl,
      prodPassportUrl = _props$prodPassportUr === void 0 ? 'https://fanruanclub.com' : _props$prodPassportUr;
  var pathname = location.pathname;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  useEffect(function () {
    if (menu && Array.isArray(menu)) {
      var findActive = false;

      for (var i = 0; i < menu.length; i++) {
        var item = menu[i];
        var re = pathToRegexp(item.path);

        if (re.test(pathname)) {
          setActiveMenu(item);
          findActive = true;
          break;
        }
      } // 没匹配到就选第一个


      if (!findActive && menu.length > 0) {
        setActiveMenu(menu[0]);
      }
    }
  }, [pathname]);
  useEffect(function () {
    function callback(data) {
      onMonitorChange === null || onMonitorChange === void 0 ? void 0 : onMonitorChange(data);
    }

    var casModule = new LoginCasSDK({
      app: 'home',
      debug: false,
      mode: env,
      getLoginUid: function getLoginUid() {
        return Number(uid) || 0;
      }
    });
    casModule.onLoginChange(callback);
  }, []);
  return /*#__PURE__*/_jsx(NavigationHeaderContext.Provider, {
    value: {
      navItem: navItem,
      searchComponent: searchComponent,
      onSiteNameClick: onSiteNameClick,
      rightMenu: rightMenu,
      onSearch: onSearch,
      siteName: siteName,
      dropDownMenu: dropDownMenu,
      onLogoClick: onLogoClick,
      activeMenuTitleOnClick: activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.onClick,
      activeMenuTitle: activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.title,
      activeMenuId: activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.id,
      device: isMobile() ? 'mobile' : 'pc',
      onLogout: onLogout,
      onLogin: onLogin,
      username: username,
      uid: uid,
      testPassportUrl: testPassportUrl,
      prodPassportUrl: prodPassportUrl,
      env: env,
      menu: menu,
      onMenuClick: onMenuClick
    },
    children: /*#__PURE__*/_jsx("header", {
      className: cx('dr-nav-wrapper', className),
      children: /*#__PURE__*/_jsxs(MediaContextProvider, {
        children: [/*#__PURE__*/_jsx(ComponentWrapper, {
          style: {
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(PcHeader, {})
        }), /*#__PURE__*/_jsx(ComponentWrapper, {
          mode: "notPC",
          className: "dr-nav-mobile-wrapper",
          children: /*#__PURE__*/_jsx(MobileHeader, {
            ref: ref
          })
        })]
      })
    })
  });
});
export default NavigationHeader;